import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faSync, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Payment } from '@modules/accounting/interfaces/payment';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StripePaymentModal from '@accounting/components/payments/stripe/stripe-payment-modal.vue';
import { getProp, setProp } from '@shared/helpers/operators';
import StripeCancelModal from '@accounting/components/payments/stripe/stripe-cancel-modal.vue';
import BPCStripeConnectService from '@accounting/services/bpc-stripe-connect-api.service';
import StripeReportModal from '@accounting/components/modals/stripe-report-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import ModulesHelper from '@core/services/modules.helper';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import moment from 'moment';

library.add(faSync, faCheck, faTimes);

const bpcStripeConnectService = new BPCStripeConnectService();

@Component({
  name: 'bpc-payment-table',
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-stripe-payment-modal': StripePaymentModal,
    'bpc-stripe-cancel-modal': StripeCancelModal,
    'bpc-stripe-report-modal': StripeReportModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-extended-filter': ExtendedFilter,
  },
})
export default class PaymentTable extends mixins(AbstractTable) {
  // @Prop(String) readonly displayConfigName: string;
  // @Prop(String) readonly title: string;
  // @Prop(String) readonly subtitle: string;

  public entity: Payment = null;
  public entityName = 'payment';
  public pluralEntityName = 'payments';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'payments';
  public showStripePaymentModal: boolean = false;
  public showStripeCancelModal: boolean = false;
  public stripeKey: number = 0;
  public payAmount: number = 0;
  public stripePaymentIntentId: string = null;
  public showStripeReportModal = false;
  public stripeReportModalId = 'stripeReportModal';
  public refreshingPayment = false;

  public customPageActions = {
    stripeReport: {
      activated: false,
      type: 'action',
      icon: 'chart-line',
      text: 'stripeReport',
      show: false,
      selectElements: false,
      tag: 'right',
      event: 'stripe-report',
      permissions: ['access_stripe_report'],
    },
    stripeConnectDashboard: {
      activated: false,
      type: 'action',
      icon: 'eye',
      text: 'stripeDashboard',
      show: false,
      selectElements: false,
      tag: 'right',
      event: 'redirect-stripe-connect',
      permissions: ['access_stripe_connect_dashboard'],
    },
  };

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  get showRefreshPaymentStatusButton(): boolean {
    return (
      this.$modulesService.hasModuleActivated(ModulesHelper.POS_MODULE_NAME) &&
      this.$authorizationService.hasPermission('manage_pos_operations') &&
      this.entity.status !== 'paid' &&
      moment(String(this.entity.payment_date)).isSame(moment(), 'day')
    );
  }

  get showForceAcceptPaymentButton(): boolean {
    return (
      this.$modulesService.hasModuleActivated(ModulesHelper.POS_MODULE_NAME) &&
      this.$authorizationService.hasPermission('manage_pos_operations') &&
      this.entity.payment_method_type === 'nepting' &&
      this.entity.status === 'ongoing' &&
      this.$authService.isAdmin()
    );
  }

  get showForceRefusePaymentButton(): boolean {
    return (
      this.$modulesService.hasModuleActivated(ModulesHelper.POS_MODULE_NAME) &&
      this.$authorizationService.hasPermission('manage_pos_operations') &&
      this.entity.payment_method_type === 'nepting' &&
      this.entity.status === 'ongoing' &&
      this.$authService.isAdmin()
    );
  }

  get showDropdownActionButton(): boolean {
    return (
      this.showRefreshPaymentStatusButton ||
      this.showForceAcceptPaymentButton ||
      this.showForceRefusePaymentButton
    );
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Payment;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onFormSave() {
    this.nextAction = '';
    if (this.$refs.stdForm.formModel.payment_method_type === 'stripe_card') {
      this.payAmount = Number(this.$refs.stdForm.formModel.paid_amount);
      this.showStripePaymentModal = true;
    } else {
      this.$refs.stdForm.saveEntity();
    }
  }

  onSuccessStripePayment($event) {
    this.stripeKey++;
    this.showStripePaymentModal = false;
    setProp(this.$refs.stdForm.formModel, 'payment_method_result', $event);
    this.$refs.stdForm.saveEntity();
  }

  onCloseStripePaymentModal() {
    this.stripeKey++;
    this.showStripePaymentModal = false;
  }

  onEntityErrorSaving() {
    const paymentMethod = getProp(this.$refs.stdForm.formModel, 'payment_method_type');
    if (paymentMethod === 'stripe_card') {
      this.stripePaymentIntentId = getProp(
        this.$refs.stdForm.formModel.payment_method_result,
        'id',
      );
      this.showStripeCancelModal = true;
    }
  }

  async setConfig($event) {
    this.config = $event;
    for (const activatedPageAction of this.config.data.activatedPageActions) {
      if (
        activatedPageAction === 'stripeConnectDashboard' ||
        activatedPageAction === 'stripeReport'
      ) {
        const connectStatus = await bpcStripeConnectService.getStripeConnectStatus();
        if (connectStatus.finished === true) {
          this.customPageActions[activatedPageAction].activated = true;
          this.customPageActions[activatedPageAction].show = true;
        }
      }
      if (
        this.customPageActions[activatedPageAction] &&
        this.customPageActions[activatedPageAction]['permissions']
      ) {
        this.checkPermission(activatedPageAction);
      }
    }
    this.updatePageActions();
    this.updateRowActions();
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'redirect-stripe-connect':
        bpcStripeConnectService.redirectStripeConnect();
        break;
      case 'stripe-report':
        this.onStripeReportClicked();
        break;
    }
  }

  onStripeReportClicked() {
    this.showStripeReportModal = true;
    console.log('Stripe report');
  }

  onCloseStripeCancelModal() {
    this.showStripeCancelModal = false;
    this.stripePaymentIntentId = null;
    setProp(this.$refs.stdForm.formModel, 'payment_method_result', null);
  }

  onShow(e) {
    this.onEdit(e, true);
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.softDelete.show =
      entity.manual &&
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;
    entity.actions.edit.show =
      entity.manual &&
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;
    return null;
  }

  /* Lifecycle hooks */

  // created() {}
  mounted() {
    this.stripeReportModalId = `stripe-report-modal-${this.generateUUIDv4()}`;
  }

  onCloseStripeReportModal() {
    this.showStripeReportModal = false;
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }

  async refreshPaymentStatus(payment: Payment) {
    this.refreshingPayment = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('pos');
    const url = `${basePath}/payments/${payment.id}/refresh-payment-status`;
    await this.$bpcApi.post(url).toPromise();
    this.i++;
    this.onRefresh();
    this.refreshingPayment = false;
  }

  async forceAcceptPayment(payment: Payment) {
    this.refreshingPayment = true;
    const url = this.$bpcApiRouteHelper.getApiPath(`pos/payments/${payment.id}/force-accept`);
    await this.$bpcApi.post(url).toPromise();
    this.i++;
    this.onRefresh();
    this.refreshingPayment = false;
  }

  async forceRefusePayment(payment: Payment) {
    this.refreshingPayment = true;
    const url = this.$bpcApiRouteHelper.getApiPath(`pos/payments/${payment.id}/force-refuse`);
    await this.$bpcApi.post(url).toPromise();
    this.i++;
    this.onRefresh();
    this.refreshingPayment = false;
  }

  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['code']];
  // updated() {}
  // destroyed() {}
}
